import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import classes from "../Sigfox/SigfoxModalForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addCamectAPI, addSensor, addSigfoxAPI, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';

const SensorIDReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}


const NBIOTSensorForm = ({ setShowVirtualSource, inputs, fetchVirtualSources, setShowSuccess }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }

    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)

    const ModalDialog = useRef();
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        HandelResetModal();
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [formIsValid, setFormIsValid] = useState(false);

    const [sensorIDState, dispatchSensorIDState] = useReducer(SensorIDReducer, {
        value: '',
        isValid: null
    });

    const sensorIDInputRef = useRef();

    const { isValid: sensorIDIsValid } = sensorIDState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            setFormIsValid(sensorIDIsValid)
        }, 500);

        return () => {
            clearTimeout(identifier);
        };
    }, [sensorIDIsValid]);

    const sensorIDChangeHandler = (event) => {
        dispatchSensorIDState({ type: 'USER_INPUT', val: event.target.value });
    }

    const validateSensorIDHandler = () => {
        dispatchSensorIDState({ type: 'INPUT_BLUR' });
    }


    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const onClearHandler = () => {
        dispatchSensorIDState({ type: 'INPUT_CLEAR', val: "" })
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();

        const sensorDetails = {
            "siteUUID": DeviceUUID,
            "sensorID": sensorIDState.value,
            "name": "",
            "input": pinSelected.toString(),
            "sensorType": 7,
        }
        console.log(sensorDetails);
        const responseData = await addSensor(apiData, sensorDetails, dispatch)
        console.log(responseData);
        if (responseData && responseData.success) {
            HandleCloseModal();
            fetchVirtualSources();
            setShowSuccess(true);
        }
    };


    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setModalComponent(
                    <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which switch would you like to link the sensor to?</h3>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                            
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {inputs.map((input) => {
                                            return (
                                                <li key={input.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(input.Pin)}>
                                                        {input.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )

                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                        <ul className={classes["inputs-list"]}>
                            <li className={classes["input-container"]}>
                                <label className={classes.subTitle}>Enter NB-IOT Sensor ID</label>
                                <Input
                                    className={classes.input}
                                    placeholder={"Sensor ID"}
                                    ref={sensorIDInputRef}
                                    id="CamectIP"
                                    type={"text"}
                                    isValid={sensorIDState.isValid}
                                    value={sensorIDState.value}
                                    onChange={sensorIDChangeHandler}
                                    onBlur={validateSensorIDHandler}
                                />

                            </li>
                        </ul>
                        <br/>
                        <Button  icon="pi pi-save" type="submit" label="Save" severity='success'/>
                        
                    </form>
                )
                HandleShowModal();
                break;
        }
    }, [modalPageIndex, sensorIDState]);

    return (
        <>
            <Modal ref={ModalDialog} title={"Add NB-IOT Sensor"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default NBIOTSensorForm;